require('./aggregatorDepositBox.scss');

import React from 'react';
import PropTypes from 'prop-types';

// @components
import { AggregatorGenericBox } from '../aggregatorGenericBox/aggregatorGenericBox';
import { AggregatorDepositDetails } from 'components/aggregator/aggregatorDetails/aggregatorDepositDetails/aggregatorDepositDetails';
import { OneLineSymbolAmount } from 'commonsComponents/oneLineSymbolAmount';

// @commons
import OKTooltip from 'components/commons/OKTooltip/OKTooltip';

// @helpers
import { formatAmountObject, getPlainAmountObject } from'utilities/currencyHelper';
import { getLastNChars } from 'utilities/stringHelper';
import { sendTextToClipBoard } from 'commonsUtilities/clipBoardHelper';

const { FormattedText } = require('core/i18n').i18n;

class AggregatorDepositBox extends React.PureComponent {

    handleCopyIbanToClipBoard = () => {
        sendTextToClipBoard(this.props.account);
    };

    buildTooltipContent = (account) => {
        return (
            <span>
                {account}
                <button
                    className="icon__tooltip icon-copiar"
                    onClick={this.handleCopyIbanToClipBoard}
                >
                </button>
            </span>
        );
    };

    renderHeader = () => {
        const { account, id, alias, balance } = this.props;

        const accountFormatted = <span className="aggregator-accounts-box-header__iban">{getLastNChars(`${account}`)}</span>;
        const tooltipContent = this.buildTooltipContent(account);
        const plainAmountObject = balance && getPlainAmountObject(balance);

        return (
            <div className="aggregator-deposits-box-header" id={id}>
                <section>
                    <div className="clearfix">
                        <div className="pull-left">
                            <div className="aggregator-deposits-box-header__title">
                                {alias}
                            </div>
                            <div className="aggregator-deposits-box-header__iban">
                                <OKTooltip
                                    content={tooltipContent}
                                    offset={[50, 10]}
                                    placement="bottom"
                                    target={accountFormatted}
                                />
                            </div>
                        </div>
                        <div className="pull-right">
                            <div>
                                <FormattedText className="aggregator-deposits-box-header__balance-title" value="accordionAccount-balance" />
                            </div>
                            {!!plainAmountObject &&
                                <div>
                                    <OneLineSymbolAmount
                                        amountObject={plainAmountObject}
                                        className="aggregator-deposits-box-header__balance-value"
                                        amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                                    />
                                </div>
                            }
                        </div>
                    </div>
                </section>
            </div>
        );
    };

    renderBody = () => {
        const { startDate, endDate, tax, balance } = this.props;

        return (
            <div className="aggregator-accounts-box-body">
                <AggregatorDepositDetails
                    startDate={startDate}
                    endDate={endDate}
                    tax={tax}
                    balance={balance}
                />
            </div>
        );
    };

    render = () => {
        return (
            <AggregatorGenericBox
                header={this.renderHeader()}
                body={this.renderBody()}
            />
        );
    };
}

AggregatorDepositBox.propTypes = {
    id: PropTypes.string,
    alias: PropTypes.string,
    balance: PropTypes.object,
    startDate: PropTypes.number,
    endDate: PropTypes.number,
    tax: PropTypes.string,
    account: PropTypes.string,
};

export { AggregatorDepositBox };
